import List from "@/components/list";
import router from "@/router";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const previewQuestion = listeners["previewQuestion"] || function () { };

  // 编辑调查
  function editExam({ uuid }) {
    router.push({ path: "/investigation/add", query: { id: uuid } });
  }

  // 删除调查
  function deleteExam(exam) {
    vue.$emit("deleteExam", exam);
  }

  // 查看调查人员
  function invesUserList(exam) {
    router.push({
      path: "investigation/members",
      query: {
        id: exam.uuid,
        investigationType: exam.investigationType,
        bizId: exam.bizId
      }
    });
  }

  // 结果统计
  function invesResult(exam) {
    router.push({
      path: "investigation/result",
      query: { id: exam.uuid }
    });
  }

  const Deal = ({ props: { vo } }) => {
    const exam = vo.row;
    const dealConf = [
      [
        exam.publishStatus === 0 ? "icon-edit" : "icon-edit-disable",
        "编辑",
        exam.publishStatus === 0
          ? () => {
              editExam(exam);
            }
          : () => {},
        "investigation:update"
      ],
      [
        exam.publishStatus === 0 ? "icon-delete" : "icon-delete-disable",
        "删除",
        exam.publishStatus === 0
          ? () => {
              deleteExam(exam);
            }
          : () => {},
        "investigation:delete"
      ],
      [
        "icon-user-list",
        "调查用户名单",
        () => {
          invesUserList(exam);
        },
        "investigation:user"
      ],
      [
        exam.investigationStatus === 2 ? "icon-result" : "icon-result-disabled",
        "结果统计",
        exam.investigationStatus === 2
          ? () => {
              invesResult(exam);
            }
          : () => {},
        "investigation:pageStatistics"
      ],
      [
        "icon-preview",
        "预览",
        () => {
          previewQuestion(exam);
        },
        "questionnaire:preview"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "问卷名称",
      prop: "questionnaireName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "调查类型",
      minWidth: "120",
      prop: "investigationTypeName"
    },
    {
      label: "关联班级",
      prop: "className",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "调查状态",
      prop: "investigationStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "150",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
